import { Patch } from 'immer';
import { Sheet } from '../types';
import { SheetGroups, EntityIdToName } from '../types/sheet/sheetGroups';
import { PrimaryStorage } from '../../core/redux/auth/authTypes';

export enum SnapshotStores {
  Snapshot = 'Snapshot', //B
  // Records = 'Records',
  // Info = 'Info', //WI
}

export enum SnapshotItem {
  Snapshot = 'snap',
  Info = 'info',
}

export enum SnapshotType {
  Sheet = 'Sheet',
  Groups = 'Groups',
  EntityIdToName = 'EntityIdToName',
  SheetsRoot = "SheetsRoot"
}

export type SnapshotResultDataType = Sheet | SheetGroups | EntityIdToName;

export interface SnapshotResult<T> {
  data: T | null;
  dataLost: boolean;
}

export interface VerifiedSerials {
  [key: number]: number;
}

export interface TempVerifiedChanges {
  serverAssignedSerial: number;
  changes: Patch[];
}

// export enum SnapshotInfoItem {
//   ActiveWAL = 'ActiveWAL',
//   LastSerial = 'LastSerial',
//   MergedWAL = 'MergedWAL',
// }

export interface SnapshotInfo {
  activeWAL: number;
  lastSerial: number;
  mergedWAL: number;
}

export const snapshotStoresSchema = Object.values(SnapshotStores).reduce(
  (stores, value) => {
    stores[value] = '++';
    return stores;
  },
  {} as { [key: string]: string }
);

export enum WALStores {
  Changes = 'Changes',
  VerifiedSerials = 'VerifiedSerials',
  MetaData = 'MetaData',
}

export enum WALMetaData { //WALInfoItem
  SerialsInitiated = 'SerialsInitiated',
  // VerifiedSerials = 'VerifiedSerials',
}

export const walStoresSchema = Object.values(WALStores).reduce(
  (stores, value) => {
    stores[value] = '++';
    return stores;
  },
  {} as { [key: string]: string }
);

export interface FileSystemWALInfo {
  recordsInfo: {
    serialStart: number;
    lastAddedRecord: number;
  };
  verifiedSerials: {
    [key: number]: number;
  };
}

export type SnapshotParams =
  | { snapshotType: SnapshotType.Sheet; sheet: Sheet }
  | { snapshotType: SnapshotType.Groups; groups: SheetGroups; }
  | {
      snapshotType: SnapshotType.EntityIdToName;
      sheetsIdToName: EntityIdToName;
    };

export type walParams = {
  walType: SnapshotType;
  changes: Patch[];
  activeWAL?: number;
  serverAssignedSerial?: number;
};

// export type UnSavedSheetHistoryParams = {
//   op: "add" | "remove"
//   unSavedSheetChange?: SheetHistory,
//   unSavedSheetHistory?: UnSavedSheetHistory
// }

export interface SheetStorageWorkerParams {
  feKey: CryptoKey;
  // userId: string;
  dbName: string;
  primaryStorage: PrimaryStorage;
  snapshotParams?: SnapshotParams;
  walParams?: walParams;
  // unSavedSheetHistoryParams?: UnSavedSheetHistoryParams
  directoryHandle?: FileSystemDirectoryHandle;
}
